module.exports = __webpack_public_path__ + "img/circle.08a4a23b.png";